import { Container } from "./container";

export type BroadcastChannel = 'extension';

export type BroadcastMessage<TContent = unknown> = {
	id?: number;
	channel?: BroadcastChannel;
	content?: TContent;
}

export class BroadcastEvent extends Event {
	constructor(type: 'broadcast', readonly message: BroadcastMessage) {
		super(type);
	}
}

export type BroadcastListener = (e: BroadcastEvent) => void;

export class Broadcast extends EventTarget {
	
	private _id = 0;
	private _listeners = new Map<number, BroadcastListener>();

	constructor(readonly container: Container) {
		super();
	}

	subscribe(listener: BroadcastListener) : number {
		const id = ++this._id;
		const eventListener = (e: BroadcastEvent) => {
			if (e.message.id == id) return; // prevents handling own broadcast
			listener(e);
		};
		this._listeners.set(id, eventListener);
		this.addEventListener('broadcast', eventListener);
		return id;
	}

	unsubscribe(id: number) {
		if (!this._listeners.has(id)) return;
		const listener = this._listeners.get(id);
		if (listener) this.removeEventListener('broadcast', listener);
		this._listeners.delete(id);
	}

	send(message: BroadcastMessage) {
		this.dispatchEvent(new BroadcastEvent('broadcast', message));
	}

}
